'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHost = exports.ModalHostUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _modals = require('redux/modules/modals');

var _decorator = require('helpers/decorator');

var _AnnouncementsModalContainer = require('containers/Announcements/AnnouncementsModalContainer');

var _CmsModal = require('components/CmsModals/CmsModal');

var _PurchaseConfirmationModal = require('components/VenueDetail/PurchaseConfirmationModal');

var _PurchaseModal = require('components/VenueDetail/PurchaseModal');

var _SaveOfferModalContainer = require('features/Settings/Membership/SaveOfferModalContainer');

var _ClassBundleModal = require('features/Settings/Membership/Bundles/ClassBundleModal');

var _ClassCancellationModal = require('containers/Profile/ClassCancellationModal');

var _ClassDetailModal = require('components/ALaCarte/ClassDetailModal');

var _ContentModal = require('components/ModalHost/ContentModal');

var _DeviceSetupModal = require('containers/DeviceSetupModal/DeviceSetupModal');

var _InviteAFriendModal = require('components/Profile/InviteAFriendModal');

var _Modal = require('containers/LocationModal/Modal');

var _PlanConfirmationModal = require('features/Settings/Membership/Plans/PlanConfirmationModal');

var _ReactivationModalContainer = require('features/Search/ReactivationModalContainer');

var _Modal2 = require('components/Reservation/Modal');

var _ReviewsModal = require('components/Explore/ReviewsModal');

var _ScheduleModal = require('components/Explore/ScheduleModal');

var _TopUpFlowModalContainer = require('features/Reservation/TopUp/TopUpFlowModalContainer');

var _VideosRatingModalContainer = require('features/Videos/VideosRatingModalContainer');

var _Modal3 = require('containers/YouTubeVideoModal/Modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_COMPONENTS = {
  ClassBundleModal: _ClassBundleModal.ClassBundleModal,
  ClassCancellationModal: _ClassCancellationModal.ClassCancellationModal,
  ClassDetailModal: _ClassDetailModal.ClassDetailModal,
  CmsModal: _CmsModal.CmsModal,
  ContentModal: _ContentModal.ContentModal,
  DeviceSetupModal: _DeviceSetupModal.DeviceSetupModal,
  InviteAFriendModal: _InviteAFriendModal.InviteAFriendModal,
  LocationModal: _Modal.Modal,
  PlanConfirmationModal: _PlanConfirmationModal.PlanConfirmationModal,
  PurchaseConfirmationModal: _PurchaseConfirmationModal.PurchaseConfirmationModal,
  PurchaseModal: _PurchaseModal.PurchaseModal,
  VideosRatingsModal: _VideosRatingModalContainer.VideosRatingModalContainer,
  ReactivationModal: _ReactivationModalContainer.ReactivationModalContainer,
  ReservationModal: _Modal2.Modal,
  ReviewsModal: _ReviewsModal.ReviewsModal,
  SaveOfferModal: _SaveOfferModalContainer.SaveOfferModalContainer,
  ScheduleModal: _ScheduleModal.ScheduleModal,
  AnnouncementsModal: _AnnouncementsModalContainer.AnnouncementsModal,
  TopUpModal: _TopUpFlowModalContainer.TopUpFlowModalContainer,
  YouTubeVideoModal: _Modal3.Modal
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    modalName: (0, _modals.selectActiveModalName)(state),
    modalProps: (0, _modals.selectActiveModalProps)(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onHideRequest: _modals.hideModal
};

var ModalHostUnwrapped = exports.ModalHostUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ModalHostUnwrapped, _PureComponent);

  function ModalHostUnwrapped() {
    (0, _classCallCheck3.default)(this, ModalHostUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (ModalHostUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ModalHostUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalHostUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          modalName = _props.modalName,
          modalProps = _props.modalProps,
          onHideRequest = _props.onHideRequest;


      if (modalName) {
        var ModalToRender = MODAL_COMPONENTS[modalName];

        if (!ModalToRender) {
          throw new Error('Cannot find modal ' + modalName);
        }

        return _react2.default.createElement(ModalToRender, (0, _extends3.default)({
          onModalClose: function onModalClose() {
            return onHideRequest(modalName);
          }
        }, modalProps));
      }

      return false;
    }
  }]);
  return ModalHostUnwrapped;
}(_react.PureComponent);

var ModalHost = exports.ModalHost = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ModalHostUnwrapped);

ModalHostUnwrapped.propTypes = {
  modalName: _propTypes2.default.string,
  modalProps: _propTypes2.default.object,
  onHideRequest: _propTypes2.default.func.isRequired
};